import { makeAutoObservable } from 'mobx'
import { restClient } from '@/Core'

/**
 * Local store of `StatusHistorySection`.
 * Owns the loaded history list, loading flag, and the status-history fetch.
 * Failures are silenced into an empty list (matches the pre-refactor view behavior).
 * Instantiated per section mount via `useState(() => new StatusHistorySectionStore())`.
 */
export class StatusHistorySectionStore {
    history: any[] = []
    loading = false

    constructor() {
        makeAutoObservable(this)
    }

    setHistory(items: any[]): void {
        this.history = items
    }

    setLoading(v: boolean): void {
        this.loading = v
    }

    async load(assignmentUuid: string): Promise<void> {
        if (!assignmentUuid) return
        this.setLoading(true)
        try {
            const data: any = await restClient.get(`/services/executor-assignments/${assignmentUuid}/status-history`)
            const items = data?.items || data?.['hydra:member'] || []
            this.setHistory(Array.isArray(items) ? items : [])
        } catch {
            this.setHistory([])
        } finally {
            this.setLoading(false)
        }
    }
}
